export enum RegionType {
    NYISO = "NYISO",
    PJM = "PJM",
    MISO = "MISO",
    CAISO = "CAISO",
    SPP = "SPP",
    ERCOT = "ERCOT",
    WECC = "WECC",
    TVA = "TVA",
    ISONE = "ISONE",
    SOCO = "SOCO",
    DUKE = "DUKE"
}

export const isKnownRegionType = (type: string): type is RegionType => {
    return Object.values(RegionType).includes(type as RegionType);
};

export const convertToRegionType = (string: string): RegionType => {
    if (isKnownRegionType(string)) {
        return string;
    }

    throw new Error("Unexpected region type");
};

export const convertToRegionTypeList = (
    stringList: ReadonlyArray<string>
): ReadonlyArray<RegionType> => {
    return stringList.filter(isKnownRegionType);
};
